export default {
  key: "6484a90a1aed5f63b746fc47ab341454",
  baseUrl: "https://api.openweathermap.org/data/2.5/",
  imgPath: "https://openweathermap.org/img/w/",
};
